
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import ModernButton from "@/components/dashboard/ModernButton";
import { Icon } from "@/components/icons";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100 dark:bg-[hsla(0,0%,0%,0.95)]">
      <div className="p-8 bg-white dark:bg-neutral-800/70 rounded-xl shadow-sm text-center max-w-md">
        <h1 className="text-3xl font-bold text-foreground mb-2">404</h1>
        <p className="text-xl text-foreground mb-4">Page not found</p>
        <p className="text-dark-gray mb-6 text-sm">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-2">
          <ModernButton asChild variant="outline">
            <Link to="/">Return to Dashboard</Link>
          </ModernButton>
          <ModernButton asChild variant="outline">
            <Link to="/help/support">Contact Support</Link>
          </ModernButton>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
